import { Routes, Route } from 'react-router-dom';
import RegisterPage from './pages/RegisterPage';
import SessionPage from './pages/SessionPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
    return (
        <Routes>
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/register/:instanceId" element={<RegisterPage />} />
            <Route path="/session" element={<SessionPage />} />
            <Route path="/session/:token" element={<SessionPage />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
}

export default App;
